define('SuiteCommerce.ItemBadges.ProductList', [
  'SuiteCommerce.ItemBadges.View'
], function ItemBadgesProductList(
  ItemBadgesView
) {
  'use strict';
  return {
    loadProductListItemBadges: function loadPDPItemBadges(application, collection) {
      var plp = application.getComponent('PLP');
      this.addProductListChildViews(plp, collection);
    },
    addProductListChildViews: function addProductListChildViews(plp, collection) {
      plp.addChildViews(
        plp.PLP_VIEW, {
          'ItemDetails.Options': {
            'Itembadges.View': {
              childViewIndex: 5,
              childViewConstructor: function childViewConstructor() {
                return new ItemBadgesView({
                  view: 'plp',
                  collection: collection
                });
              }
            }
          }
        }
      );
    }
  };
});
